import { Injectable } from '@angular/core';
import { KeycloakLoginOptions } from 'keycloak-js/lib/keycloak';
import { AuthRedirectDebugDetails, AuthRedirectDebugService } from '../auth-redirect-debug.service';
import { AuthRedirectReason } from '../auth-redirect-reason';
import { KeycloakClientService } from './keycloak-client.service';

@Injectable({
    providedIn: 'root',
})
export class AuthLoginService {
    constructor(
        private keycloakClient: KeycloakClientService,
        private authRedirectDebug: AuthRedirectDebugService
    ) {}

    async login(options: KeycloakLoginOptions = {}): Promise<void> {
        await this.keycloakClient.login(options);
    }

    /**
     * Redirects to Keycloak login when the session cannot be recovered programmatically.
     * Do not call clearToken(): keycloak-js would auto-call login() without prompt.
     */
    redirectToLogin(lastDebug?: {
        reason: AuthRedirectReason;
        details: AuthRedirectDebugDetails;
    }): void {
        if (!this.keycloakClient.isInitialized()) {
            return;
        }

        const redirectUri = window.location.origin + window.location.pathname;

        if (lastDebug) {
            this.authRedirectDebug.log(lastDebug.reason, {
                ...lastDebug.details,
                redirectUri,
            });
        }

        void this.keycloakClient.login({ redirectUri, prompt: 'login' });
    }
}
